<template>
  <div id="pageContent">
    <TopBanner :bg-img="bgImg"
               :sub-title="mainTitle"/>
    <TabDepthMenu :key="slidesPerView" :tab-list="tabList" :slides-per-view="slidesPerView" />
    <router-view className="contents"></router-view>
  </div>
</template>

<script>
import TopBanner from '@/components/Common/TopBanner.vue';
import TabDepthMenu from '@/components/Common/TabDepthMenu.vue';

export default {
  name      : 'ClubView',
  components: {TabDepthMenu, TopBanner},
  data() {
    return {
      bgImg    : 'clubList',
      mainTitle: '클럽',
      tabList  : [],
      isMobile: true,
      slidesPerView: 4
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.$nextTick(() => {
      this.onResize()
    })
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 1100;
      this.slidesPerView = this.isMobile ? 3 : 4;
    }
  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });

    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      return x.meta && x.meta.title;
    });

    Object.entries(subMenuList).forEach(([, value]) => {
      const result = {
        title   : value.meta.title,
        name    : value.name,
        isActive: this.$route.name === value.name
      }
      this.tabList.push(result);
    });
  },
}
</script>
